import { MENU_BIG, MENU_SMALL } from '@constants/menu.contant';
import { SEARCH_CONTAINER_HEIGHT } from '@features/customers/constants/search.constants';
import { makeStyles } from '@mui/styles';

const useCustomersContainerStyles = makeStyles({
	headerContainer: {
		alignItems: 'center',
		backgroundColor: 'white',
		boxShadow: '0px 3px 6px #0000000D',
		display: 'flex',
		height: SEARCH_CONTAINER_HEIGHT,
		justifyContent: 'center',
		padding: `8px 0`,
		position: 'fixed',
		zIndex: 1200,
	},
	headerContainerBig: {
		width: `calc(100% - ${MENU_BIG})`,
	},
	headerContainerSmall: {
		width: `calc(100% - ${MENU_SMALL})`,
	},
	elementContainer: {
		marginTop: SEARCH_CONTAINER_HEIGHT,
	},
});

export default useCustomersContainerStyles;
